<template>
    <div>
        <input type="file" :accept="inputFile.accept" @change="selectedFile(arguments[0])">
        <div v-if="input.file" class="l-mt5">
            <div>
                <a v-if="checkingFilesExtension" :href="thumbnail.path" target="_blank">
                    <img src="@/assets/images/pdf-image.png" :width="thumbnail.pdf.width" :height="thumbnail.pdf.height" :alt="thumbnail.pdf.alt">
                </a>
                <img v-else :src="thumbnail.path" :width="thumbnail.image.width" :height="thumbnail.image.height" :alt="thumbnail.image.alt">
            </div>
        </div>
        <div v-else-if="inputFile.thumbnail.path" class="l-mt5">
            <div>
                <a v-if="checkingFilesExtension" :href="inputFile.thumbnail.path" target="_blank">
                    <img src="@/assets/images/pdf-image.png" :width="thumbnail.pdf.width" :height="thumbnail.pdf.height" :alt="thumbnail.pdf.alt">
                </a>
                <img v-else :src="inputFile.thumbnail.path" :width="thumbnail.image.width" :height="thumbnail.image.height" :alt="thumbnail.image.alt">
            </div>
            <div class="l-mt1">
                <input :id="`delete_flag_${inputFile.id}`" v-model="deleteFlag" type="checkbox" true-value="1" false-value="0">
                <label class="is-text-red" :for="`delete_flag_${inputFile.id}`">削除</label>
            </div>
        </div>
    </div>
</template>

<script>
    "use strict";

    export default {
        "props": {
            "inputFile": {
                "required": true,
                "type": Object,
            },
        },
        data() {
            return {
                "input": {
                    "delete_flag": "0",
                    "file": "",
                },
                "thumbnail": {
                    "image": {
                        "alt": "",
                        "height": "240",
                        "width": "",
                    },
                    "path": "",
                    "pdf": {
                        "alt": "",
                        "height": "240",
                        "width": "",
                    },
                },
            };
        },
        "computed": {
            checkingFilesExtension() {
                let path = this.inputFile.thumbnail.path;
                if (this.input.file) {
                    if (this.input.file.name) {
                        path = this.input.file.name;
                    }
                }
                const extension = path.split(".").slice(-1)[0].toLowerCase();
                if (extension === "pdf") {
                    return true;
                } else {
                    return false;
                }
            },
            "deleteFlag": {
                get() {
                    return this.input.delete_flag;
                },
                set(val) {
                    this.$emit("delete-flag", val);
                    return this.input.delete_flag = val;
                },
            },
        },
        "methods": {
            selectedFile(e) {
                e.preventDefault();
                let files = e.target.files;
                this.input.file = files[0];
                if (this.input.file) {
                    this.thumbnail.path = URL.createObjectURL(this.input.file);
                }
                this.$emit("data", this.input.file);
            },
        },
    };
</script>

<style lang="scss" scoped>
    img {
        height: 200px;
    }
</style>
